/**
 * Транспорт для пересылки логов из браузера на сервер.
 *
 * @type {{register: (function(ServiceLocator))}}
 */
module.exports = {
    /**
     * @param {ServiceLocator} locator
     */
    register (locator) {
        var config = locator.resolve('config');
        var window = locator.resolve('window');
        var logger = locator.resolve('logger');
        var uhr = locator.resolve('uhr');

        var headers = {
            'Content-Type': 'application/json'
        };

        logger.addEnrichment((log) => {
            log.userHRef = window.location.href;
        });
        logger.addEnrichment((log) => {
            log.userAgent = window.navigator.userAgent;
        });
        logger.addEnrichment((log) => {
            log.userReferrer = window.document.referrer;
        });

        var protocol = window.location.protocol;
        var host = window.location.host;
        var url = config.logger.url;

        logger.addTransport((level, log) => {
            if (!/(error|fatal|warn)/.test(level)) {
                return;
            }

            var options = {
                headers,
                data: {
                    log, level
                }
            };
            uhr.post(`${protocol}//${host}/external/${url}`, options);
        });
    }
};




// WEBPACK FOOTER //
// ./services/transport/server.js